var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<!--Note: only used in NotesLayout for now-->\n\n<div id=\""
    + container.escapeExpression(((helper = (helper = helpers.paneId || (depth0 != null ? depth0.paneId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"paneId","hash":{},"data":data}) : helper)))
    + "\" class=\"sub-side-content no-padding\">\n    <div class=\"spWr\">\n        <div class=\"sp-header\"></div>\n        <div class=\"sp-body\"></div>\n    </div>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/subSidePane.hbs
 ** module id = 519
 ** module chunks = 0
 **/